// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"preRecordedVideos_scrollbar__1GsYy"};